import { useIntl } from 'react-intl'

import { LiveUser } from 'shared/types/global'
import LiveAvatar from 'shared/ui/LiveAvatar'

import { GridContainer, GridText } from './Styles'

type BlockingUserProps = {
  editingLiveUser: LiveUser
}

const BlockingUserOverlay: React.FC<BlockingUserProps> = ({
  editingLiveUser
}) => {
  const { firstName } = editingLiveUser
  const { formatMessage } = useIntl()

  return (
    <GridContainer>
      <LiveAvatar liveUser={editingLiveUser} size={64} />
      <GridText>
        {formatMessage({ id: 'Pages.page.editing' }, { firstName })}
      </GridText>
    </GridContainer>
  )
}

export default BlockingUserOverlay
